import { QueryClient } from '@tanstack/react-query';

// 24 hours in milliseconds
const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: TWENTY_FOUR_HOURS,
      gcTime: TWENTY_FOUR_HOURS, // Previously called cacheTime in v4
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

